/**
 * Cor de cada boia nas séries.
 *
 * **A cor segue a boia, nunca a ordem de clique.** N3 é da mesma cor no gráfico
 * de temperatura, no do sonar, na ficha de comparação e na sessão de amanhã.
 * Se a cor viesse da posição na lista, tirar uma boia da comparação repintava
 * as que ficavam — e a leitura passava a depender do filtro.
 *
 * Paleta categórica validada (`validate_palette.js`, luz e escuro): banda de
 * luminosidade, piso de croma, separação para daltonismo e piso de visão normal
 * passam nos dois modos. O pior par adjacente dá ΔE 9,1 (protanopia) em claro e
 * 8,4 em escuro, contra alvo de 8.
 *
 * **O verde ficou de fora de propósito.** O verde de série (`#008300`) fica a
 * ΔE 9,7 do verde de estado (`#0ca30c`) — abaixo do piso de 15 — e nesta
 * dashboard os dois aparecem lado a lado: marcadores do mapa e barras de
 * disponibilidade usam as cores de estado. Entra violeta no lugar dele.
 */

/** Cores de estado, reservadas. Nunca servem de cor de série. */
export const ESTADO = { boa: "#0ca30c", aviso: "#fab219", critica: "#d03b3b" } as const;

const CLARO = ["#2a78d6", "#eb6834", "#1baf7a", "#eda100", "#e87ba4", "#4a3aa7"];
const ESCURO = ["#3987e5", "#d95926", "#199e70", "#c98500", "#d55181", "#9085e9"];

/**
 * Índice fixo a partir do código da boia: `N1` → 0, `N6` → 5.
 *
 * Um código fora de `N1..N6` cai no resto da divisão em vez de rebentar — a
 * frota pode crescer e um gráfico sem cor é pior que uma cor repetida.
 */
function indice(code: string): number {
  const n = Number.parseInt(code.slice(1), 10);
  return Number.isNaN(n) ? 0 : (n - 1 + CLARO.length) % CLARO.length;
}

export function corDaBoia(code: string, escuro: boolean): string {
  const paleta = escuro ? ESCURO : CLARO;
  return paleta[indice(code)] ?? paleta[0]!;
}
